
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'

var SealApplyPage = Vue.extend({})
Vue.component('sealApply-page', SealApplyPage)

export default {
name: 'SealApplyPage',
directives: {
TransferDom
},
components: {
XTable,XDialog,XButton,XInput,Group,Selector,CellBox,
PopupHeader,Popup,Radio,XTextarea,InlineXSwitch,Checklist
},
props: {
saveStatus: Number
},
data () {
return {
baseUrl: this.$store.state.url,
flowId: '',
info: {},
showToast: false,//弹窗-dialog


businessShow: false,
businessName: '',//dialog-业务名称
selectorList: [],//dialog-业务类型
selectorValue: '',//dialog-业务类型-val

preStatus: true,
nextStatus: false,

businessList: [],//dialog-业务搜索结果
businessNameList: [],//dialog-业务搜索结果
businessAllNum: '',//dialog-业务总个数
businessChoosed: {},//dialog-选择的业务
pageNum: 1,//dialog-业务搜索结果-页码
switchValue: false,//dialog-选择业务switch



refRecordId: '',
refModule: '',


useReason: '',//盖章事由
sendUnit: '',//报送单位
fileNames: '',//文件名称
fileNumber: '',//份数

fileTypeList: [],//文件类型
fileTypeValue: '',
fileTypeLabel: '',
fileTypeId: '',//文件类型ID

selectModelFlag: false, //下拉选择弹框控制
selectModelTitle: '', //下拉选择弹框标题
selectModelData:[], //下拉选择弹框数据
selectModel: '',

fileObj: {},//盖章文件上传集合
fileShowList: [],//上传盖章文件集合-预览
uploadedFileIdList: [],//已上传盖章文件ID集合

sealNumber: '',//盖章数量
remark: '',
isBusinessSeal: false,//是否用于抵扣费用报销(不计入成本)
isBusinessSealVal: 0,//是否用于抵扣费用报销(不计入成本)

sealCompanyShow: false,//公司章show
sealSubCompanyShow: false,//分/子公司章show

companySealTypesShow: false,
subCompanySealTypesShow: false,

companySealTypesList: [],//公司章
sealShowList: [],//公司章
sealChoosedId: [],//dialog-选择的公司章ID
sealChoosedName: [],//dialog-选择的公司章 或 分/子公司章NAME

sealShowChoosedList: [],//已选的公司章+分/子公司章
sealShowChoosedListVal: {},//已选的公司章+分/子公司章 列表选中行-内容

subTreeShow: false,//分/子公司树
subSealShowList: [],//分/子公司章
subSealChoosedId: [],//dialog-选择的分/子公司章ID
treeData: [],//分/子公司树数据
treeProps: {
children: 'children',
label: 'name'
},
subCompanySealTypesPartShow: false,//分/子公司章show

sealNumber: '',//盖章数量

}
},
mounted () {
this.getFileType();
this.$emit('sendTitleToParent','盖章申请');
this.axios({
url: this.baseUrl+'/wechat/sealBusiness/modSealBusiness',
method: 'get'
}).then((response) => {
this.info = response.data.obj;
this.refRecordId = response.data.refRecordId;
this.refModule = response.data.refModule;
}).catch((response) => {
this.$vux.loading.hide();
});
},
methods: {
showMsg (msg) {
this.$vux.alert.show({
title: msg
})
setTimeout(() => {
this.$vux.alert.hide()
}, 2000)
},
openDialog (v) {// 打开选择业务-dialog
this.businessShow = false;
this.companySealTypesShow = false;
this.subCompanySealTypesShow = false;
this.sealCompanyShow = false;
this.sealSubCompanyShow = false;
this.subCompanySealTypesPartShow = false;
this.showToast = true;
if(v == 'business'){//所属业务
this.businessShow = true;
this.getBusinessList();
this.searchBusiness();
}else if(v == 'companySealTypes'){//公司章
this.sealShowList = [];
this.getCompanySealTypes();
this.sealCompanyShow = true;
this.companySealTypesShow = true;
}else if(v == 'subCompanySealTypes'){//分/子公司章
this.subSealShowList = [];
this.sealSubCompanyShow = true;
this.getSubCompanyTree();
this.subCompanySealTypesShow = true;
}
},
getPrePage () {//dialog-上一页
if(this.pageNum == 1){
this.preStatus = true;
}else{
this.businessChoosed = {};
this.nextStatus = false;
this.pageNum--;
this.searchBusiness();
}
},
getNextPage () {//dialog-下一页
if(this.pageNum == this.businessAllNum){
this.nextStatus = true;
}else{
this.businessChoosed = {};
this.preStatus = false;
this.pageNum++;
this.searchBusiness();
}
},
chooseBusiness () {//dialog-确定
this.showToast = false;
},
clearBusiness () {// 清除业务
this.businessChoosed = {};
},
async getBusinessList () {
let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/listRefFlowTypes',
method: 'get'
});
this.selectorList = res.data.list;
},
async searchBusiness () {// dialog-搜索业务
this.businessList = [];
let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/businessList?businessName='+this.businessName+'&flowType='+this.selectorValue+'&page='+this.pageNum+'&rows=15',
method: 'get'
});
this.$vux.loading.hide();
this.businessList = res.data.list;
let businessLength = res.data.list.length;
for(let i=0;i<businessLength;i++){
this.businessNameList.push(res.data.list[i].businessName);
}
this.businessAllNum = Math.ceil(res.data.total/15);
},
async getFileType () {//获取文件类型
let res = await this.axios({
url: this.baseUrl+'/wechat/sealBusiness/fileTypes',
method: 'get'
});

let list = res.data.list;
this.fileTypeList.push({id:'',name:''});
for(let i=0;i<list.length;i++){
this.fileTypeList.push(list[i]);
}

},
openSelectModelFlage(type,data){//文件类型
this.selectModelData = [];
if(type == 'fileType'){
this.selectModelTitle = '请选择文件类型';
this.selectModel = this.fileTypeLabel;
data.forEach((item) => {
item.key = item.id;
item.value = item.name;
this.selectModelData.push(item);
})
}
this.selectModelFlag = true;
},
getLeaveType (value, label) {//文件类型
this.fileTypeId = value;
let isChange = label == this.selectModel ? false : true
if(this.selectModelTitle == '请选择文件类型'){
this.selectModel = this.payTypeVal = label
this.fileTypeLabel = label
}
if(isChange){
this.selectModelFlag = false;
}
},
chooseFile () {// 选择盖章文件
this.fileObj = document.getElementById('file').files;
this.$vux.loading.show({
text: '保存中'
});
this.submitFile();
},
deleteFile (index) {// 删除已选盖章文件
this.fileShowList.splice(index,1);

let deleteFileId = this.uploadedFileIdList[index];
let fileData = new FormData();
fileData.append("fileId",deleteFileId);

this.axios({
url: this.baseUrl+'/wechat/commonFile/deleteFile',
method: 'post',
data: fileData
}).then((response) => {
console.log('费用报销deleteFile',response);
this.uploadedFileIdList.splice(index,1);
}).catch((response) => {
this.$vux.loading.hide();
});

},
async submitFile () {// 上传盖章文件-图片
let fileObjL = this.fileObj.length;
for(let i=0;i<fileObjL;i++){
let fileData = new FormData();
fileData.append("file",this.fileObj[i]);
fileData.append("taskId",this.info.id);
fileData.append("refRecordId",this.refRecordId);
fileData.append("refModule",this.refModule);

let res = await this.axios({
url: this.baseUrl+'/wechat/commonFile/uploadFile',
method: 'post',
data: fileData
});
this.uploadedFileIdList.push(res.data.fileId);

let that = this;
let file = this.fileObj[i];
let reader = new FileReader();
reader.readAsDataURL(file);
reader.onload=function(e) {
that.fileShowList.push(this.result);
}
}

this.$vux.loading.hide();
},
switchVal (data) {//switch
if(data){
this.isBusinessSealVal = 0;
}else{
this.isBusinessSealVal = 1;
}
},
async getCompanySealTypes () {//获取公司章
let res = await this.axios({
url: this.baseUrl+'/wechat/sealBusiness/companySealTypes',
method: 'get'
});
this.companySealTypesList = res.data.list;
this.companySealTypesList.forEach((item) => {
item.key = item.id;
item.value = item.name;
})
this.sealShowList = this.companySealTypesList;
},
async getSubCompanyTree () {//获取分/子公司树
let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/subCompanyTree',
method: 'get'
});
this.treeData = res.data;
this.subTreeShow = true;
},
getCheckedNodes() {//审批-组织架构树

let checkedPersonArr = this.$refs.tree.getCheckedNodes();

this.checkDeptResult = checkedPersonArr[0];
this.checkDeptResultName = this.checkDeptResult.name;
this.subTreeShow = false;
this.subCompanySealTypesPartShow = true;
this.getsubCompanySealTypes();
},
async getsubCompanySealTypes () {//获取分/子公司章
let res = await this.axios({
url: this.baseUrl+'/wechat/sealBusiness/subCompanySealTypes?orgId='+this.checkDeptResult.id,
method: 'get'
});
if(res.data.list.length>0){
this.subSealShowList = res.data.list;
this.subSealShowList.forEach((item) => {
item.key = item.id;
item.value = item.name;
})
}else{
this.subSealShowList = [];
this.showMsg('无 分/子公司章')
}
},
backToSubCompanyTree () {
this.subCompanySealTypesPartShow = false;
this.subTreeShow = true;
},
changeCheckList (value, label) {//公司章选择
this.sealChoosedId = value;
this.sealChoosedName = label;
},
saveCompanySeal (type) {//保存公司章 或 分/子公司章

let formData = new FormData();
let sealTypeIdStr = this.sealChoosedId.join(',');
formData.append("taskId",this.info.id);
formData.append("sealTypeId",sealTypeIdStr);
if(type == 'companySeal'){//保存公司章
formData.append("organizationName",'公司章');
}else if(type == 'subCompanySeal'){//保存分/子公司章
formData.append("organizationName",'分/子公司章');
formData.append("haveSealId",this.checkDeptResult.id);
formData.append("haveSealName",this.checkDeptResult.name);
}

this.axios({
url: this.baseUrl+'/wechat/sealBusiness/saveCompanySeal',
method: 'post',
data: formData
}).then((response) => {
if(response.data.status == 1){
this.showToast = false;
this.sealShowChoosedList = response.data.sealList;
this.sealNumber = response.data.sealNumber;
this.showMsg(response.data.msg);
}else{
this.showMsg(response.data.msg);
}
}).catch((response) => {
this.$vux.loading.hide();
});

},
deleteSeal() {

let delId = this.sealShowChoosedList[this.sealShowChoosedListVal].id;
let formData = new FormData();
formData.append("taskId",this.info.id);
formData.append("id",delId);

this.axios({
url: this.baseUrl+'/wechat/sealBusiness/delSeal',
method: 'post',
data: formData
}).then((response) => {
console.log('删除公司章 或 分/子公司章',response.data);
if(response.data.status == 1){
this.sealShowChoosedList = response.data.sealList;
this.sealNumber = response.data.sealNumber;
this.showMsg(response.data.msg);
console.log(this.sealShowChoosedList);
}else{
this.showMsg(response.data.msg);
}
}).catch((response) => {
this.$vux.loading.hide();
});
},
saveForm () {//保存
if(this.useReason == ''||this.sendUnit == ''||this.fileNames == ''){
this.showMsg('请补充必填信息');
return false;
}
this.$vux.loading.show({
text: '加载中'
});

let formData = new FormData();
formData.append("id",this.info.id);

if(this.businessChoosed){
formData.append("businessId",this.businessChoosed.id);
formData.append("businessReport",this.businessChoosed.reportNo);
formData.append("businessName",this.businessChoosed.businessName);
}

formData.append("useReason",this.useReason);
formData.append("sendUnit",this.sendUnit);
formData.append("fileNames",this.fileNames);
formData.append("fileNumber",this.fileNumber);
formData.append("fileType",this.fileTypeLabel);
formData.append("sealNumber",this.sealNumber);
formData.append("isBusinessSeal",this.isBusinessSealVal);
formData.append("remark",this.remark);
formData.append("businessFlowId",this.info.flowId);

this.axios({
url: this.baseUrl+'/wechat/sealBusiness/saveForm',
method: 'post',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/x-www-form-urlencoded'
},
data: formData,
}).then((response) => {
console.log('盖章saveForm',response.data,this.saveStatus);
if(response.data.status == 0){//保存失败
this.$vux.loading.hide();
this.showMsg(response.data.msg);
}else if(this.saveStatus == 0&&response.data.status == 1){//父组件操作发起，并且保存成功
this.startFlow();
}else if(this.saveStatus == 1&&response.data.status == 1){//父组件操作提交，并且保存成功
this.$emit('sendStatusToParent',{status:1});
this.$vux.loading.hide();
}
}).catch((response) => {
this.$vux.loading.hide();
});
},
startFlow () {//发起
let startData = new FormData();
startData.append("id",this.info.id);
this.axios({
url: this.baseUrl+'/wechat/sealBusiness/startFlow',
method: 'post',
headers: {
'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
},
data: startData
}).then((response) => {
console.log('盖章startFlow',response.data);
this.showMsg('保存成功！请继续完成提交操作！');

if(response.data.status == 1){

this.$emit('sendStatusToParent',{
status:0,
id:response.data.taskId,
stepId:response.data.stepId
});
}
this.$vux.loading.hide();
}).catch((response) => {
this.$vux.loading.hide();
});

}
}
}



// WEBPACK FOOTER //
// ./src/components/launch/attendance/sealApply.vue